import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
// hooks
import { useFetchOffers } from '../offers/hooks/useFetchOffers';
// components
import { DepositsRenovationFooter } from '../deposits/depositsRenovationFooter/depositsRenovationFooter';
import { LoadingSection } from 'commonsComponents/loadingSection';
// helpers
import { offersDepositAdapter } from '../offers/adapters/depositsAdapter';
import { getCompleteRenovationState } from '../offers/helpers/depositOffersItemHelper';
import { getDepositOfferData } from '../../utilities/depositHelper';
// constants
import { DEPOSITS_SUMMARY_PAGE } from '../deposits/constants/depositsConstants';

const DepositOfferSection = ({
    depositId,
    history,
    immDeposits,
    originCountry,
    immOffers,
    immProfile,
    requestOffers,
    flagBasedFeatures,
    onDataReceived,
    goToDepositsCallback,
    onHideOfferPost,
    hideOfferPostState,
    resetHideDepositOfferPost
}) => {
    const { parsedOffers, loading, refetchOffers } = useFetchOffers({
        adapter: offersDepositAdapter,
        flow: DEPOSITS_SUMMARY_PAGE,
        requestOffers,
        immOffers,
        immDeposits,
        depositId,
        originCountry,
        featureFlags: flagBasedFeatures
    });
    const immDeposit = immDeposits.getIn(['byId', depositId]);
    const immImpositionListByOrder = immDeposit.getIn(['impositionList', 'byOrder']);
    
    useEffect(() => {
        if (parsedOffers) {
            onDataReceived(parsedOffers.examples);
        }
    }, [parsedOffers, onDataReceived]);
    
    useEffect(() => {
        const hideOfferSuccess = hideOfferPostState.success
        if (hideOfferSuccess) {
            refetchOffers()
            resetHideDepositOfferPost()
        }
    }, [hideOfferPostState])

    const { offers } = parsedOffers || {};

    if (loading) {
        return <LoadingSection />;
    }

    if (!offers) {
        return null;
    }

    const renovationState = getCompleteRenovationState(immImpositionListByOrder, offers, immDeposit);
    if (renovationState.haveRenovated) {
        return null;
    }
    
    const depositOfferData = getDepositOfferData(immDeposit.getIn(['contract', 'contractNumber']), offers);

    const taggingData = {
        type: immDeposit.get('depositType'),
        subType: immDeposit.get('depositSubType'),
        standard: immDeposit.get('depositStandard')
    };

    return (
        <DepositsRenovationFooter
            history={history}
            renovationState={renovationState}
            goToDepositsCallback={goToDepositsCallback}
            offerData={depositOfferData}
            immDeposit={immDeposit}
            immProfile={immProfile}
            immFlagBasedFeatures={flagBasedFeatures}
            isLargeDisplayOption
            taggingData={taggingData}
            originCountry={originCountry}
            onHideOfferPost={onHideOfferPost}
            hideOfferPostState={hideOfferPostState}
            resetHideDepositOfferPost={resetHideDepositOfferPost}
        />
    );
};

DepositOfferSection.propTypes = {
    depositId: PropTypes.string,
    history: PropTypes.object,
    immDeposits: PropTypes.object,
    originCountry: PropTypes.string,
    immOffers: PropTypes.object,
    immProfile: PropTypes.object,
    requestOffers: PropTypes.func,
    flagBasedFeatures: PropTypes.object,
    onDataReceived: PropTypes.func,
    goToDepositsCallback: PropTypes.func,
    onHideOfferPost: PropTypes.func.isRequired,
    hideOfferPostState: PropTypes.object.isRequired,
};

export default DepositOfferSection;
